import { createActionTypeModel } from "../../../../store/global/action-model";

export const Invoice_Projects = createActionTypeModel('Invoice_Projects')
export const Invoice_Project_Details = createActionTypeModel('Invoice_Project_Details')
export const InvoiceProjectDetails = createActionTypeModel('InvoiceProjectDetails');
export const SELECT_INVOICE_PROJECT_AUTO = 'SELECT_INVOICE_PROJECT_AUTO';
export const MODIFY_INVOICE_PROJECT = 'MODIFY_INVOICE_PROJECT';
export const UPDATE_B2B_TEXT_ELEMENTS = 'UPDATE_B2B_TEXT_ELEMENTS';
export const SET_B2B_TEXT_ELEMENTS = 'SET_B2B_TEXT_ELEMENTS';